<script setup lang="ts">
import { computed, defineProps } from "vue";
import { BoundingBox, MiddlePoint } from "@/types/stage";

const props = defineProps<{
  facadeDirection: number | null;
  boundingBox: BoundingBox | null;
  middlePoint: MiddlePoint | null;
}>();

const arrowHeight = computed(() => {
  if (props.facadeDirection === null) {
    return null;
  }
  if (props.facadeDirection === 90 || props.facadeDirection === 270) {
    return props.boundingBox?.width;
  }

  return props.boundingBox?.height;
});

const tailConfig = computed(() => ({
  points: [0, 0, 100, 0, 50, 0, 50, 20],
  stroke: "red",
  strokeWidth: 5,
  closed: false,
}));

const triangleConfig = computed(() => ({
  points: [0, 0, 50, 50, 100, 0],
  fill: "red",
  stroke: "red",
  strokeWidth: 2,
  closed: true,
  x: 0, // относительно группы
  y: arrowHeight.value || 50, // расстояние от хвоста
}));

const groupConfig = computed(() => ({
  x: props.middlePoint?.x,
  y: props.middlePoint ? props.middlePoint.y + 10 : null,
  width: 100,
  rotation: (props.facadeDirection ? props.facadeDirection : 0) + 180,
  offsetX: 50,
  offsetY: arrowHeight.value ? arrowHeight.value / 2 + 10 : null,
}));

const showAzimuthArrow = computed(
  () => props.middlePoint && props.boundingBox && props.facadeDirection !== null
);
</script>

<template>
  <v-group v-if="showAzimuthArrow" :config="groupConfig">
    <v-line :config="tailConfig" />

    <v-line :config="triangleConfig" />
  </v-group>
</template>
